import React from 'react';
import config from '@/config';
import proptypes from 'prop-types';

import './base.scss';
import { Layout } from 'antd';
import Header from './header';
import SiteMenu from './site-menu';
import Footer from './footer';

const { Content } = Layout;

const Base = ({ children }) => {
  const { pathname } = window.location;
  if (PUBLIC_URL.includes(pathname)) {
    return children;
  }
  return (
    <Layout>
      <Header />
      <Layout>
        <SiteMenu />
        <Content className="main">{children}</Content>
        <Footer />
      </Layout>
    </Layout>
  );
};

Base.propTypes = {
  children: proptypes.oneOfType([proptypes.object, proptypes.array]),
};

export default Base;

const PUBLIC_URL = [
  `${config.contextPath}/login`,
  `${config.contextPath}/request-reset-password`,
  `${config.contextPath}/reset-password`,
  '/auth/redirect',
];
